import { Injector } from '@angular/core';
import {
  ActionButtonOutcomesType,
  BaseWidgetProperties,
  InvitationType,
  SendInvitationRequest,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { InvitationService } from '../../../services/invitation-service/invitation.service';
import { WorkflowFormsService } from '../../../services/workflow-forms/workflow-forms.service';
import { FormID } from '@finxone-platform/form-action';
import { UpdateFormDataActionWithId } from '../../../actions/form-submission.action';
import { handleRedirection } from '../cta-redirection.utils';
import { take } from 'rxjs';
import { FormActionState } from '../../../state/form-submision.state';

export function inviteJointAccountRequest(injector: Injector, widgetProperties: BaseWidgetProperties): void {
  const store = injector.get(Store);
  const invitationService = injector.get(InvitationService);
  const workflowFormsService = injector.get(WorkflowFormsService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const ctaAction = widgetProperties.buttonActionType as string;

  const formValues = store.selectSnapshot(
    FormActionState.getFormActionStateWithId(FormID.INVITE_JOINT_ACCOUNT),
  )?.formData;

  const currentPageFormValidity = workflowFormsService.currentPageFormsValid();

  if (!formValues || !Object.keys(formValues).length) return;

  ctaButtonSignalService.setSignal({ [ctaAction]: false });

  if (!formValues.productCode || !formValues.inviteeEmail || !currentPageFormValidity) {
    workflowFormsService.markFormTouched(FormID.INVITE_JOINT_ACCOUNT);
    return;
  }

  const payload: SendInvitationRequest = {
    type: InvitationType.JOINT_ACCOUNT,
    productCode: String(formValues.productCode),
    inviteeEmail: formValues.inviteeEmail,
  };

  invitationService
    .sendInvitation(payload)
    .pipe(take(1))
    .subscribe({
      next: (res) => {
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        store.dispatch(new UpdateFormDataActionWithId(res, FormID.INVITE_JOINT_ACCOUNT));
        if (widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS]) {
          handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true);
        }
      },
      error: (err) => {
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        store.dispatch(new UpdateFormDataActionWithId({ status: 'FAILED' }, FormID.INVITE_JOINT_ACCOUNT));
        if (widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.FAILURE]) {
          handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.FAILURE, true);
        }
        console.error(err);
      },
    });
}
